import { PipeTransform } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

export interface TableConfigs {
  selectedAll?: boolean;
  order?: boolean;
  pagination?: boolean;
  showHeader?: boolean;
  search?: boolean;
  searchField?: Array<string>;
  currentPage?: number;
  itemsPerPage?: number;
  total?: {
    view: boolean;
    text: string;
  }
}

export interface tableHeaderItems<T = any> {
  scope?: string;
  class?: string;
  text: string;
  title?: string;
  field: string;
  orderBy?: string;
  html?: HTMLElement;
  width?: string;
  pipe?: string | PipeTransform;
  value?: (item: T) => any;
  selected?: boolean;
  originalValue?: { [key: string]: any };
}

export interface tableActions<T = any> {
  action: string;
  data: T;
}


export interface TableCellData {
  originalValue: any;
  value: string;
  slug: string;
  col: tableHeaderItems;
}

export interface tableButtons {
  isLink?: boolean;
  isPath?: string;
  className?: string;
  icon?: string;
  text: string;
  action: string;
}

export class TableComponentRow {
  selected = false;
  rendered: { [key: string]: string | SafeHtml } = {};
  value: { [key: string]: string } = {};
  originalValue: { [key: string]: any } = {};


  constructor(public data: any) {
  }

  toggleSelect() {
    this.selected = !this.selected;
  }
}


export interface tableBodyItems<T = any> {
  class?: string;
  text: string;
}

export type SortColumn = keyof tableBodyItems | '';
export type SortDirection = 'asc' | 'desc';
export const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': 'asc', '': 'asc' };
export const compare = (v1: string | number, v2: string | number) => v1 < v2 ? -1 : v1 > v2 ? 1 : 0;


export interface SortEvent {
  column: SortColumn;
  direction: SortDirection;
}
